angular.module("FavoriteModels", []).factory("FavoriteModels", [
    "$http",
    "$filter",
    "USER",
    "IdentityFactory",
    "ASSET_SHOP_API_URL",
    function ($http, $filter, USER, IdentityFactory, ASSET_SHOP_API_URL) {

        //MS-12
        var favoriteModels = [];

        function getFavoriteModels() {
            return new Promise(function(resolve, reject) {
                IdentityFactory.getUser()
                .then((res) => {
                    fetch(`${ASSET_SHOP_API_URL}/favorites`, {
                        headers: {
                            Authorization: `Bearer ${res.access_token}`,
                        },
                    }).then((body) => {
                        body.json()
                        .then((json) => {
                            const favoriteModelIds = json.data.filter((x) => x.isActive);
                            favoriteModels = favoriteModelIds.map((x) => x.modelId).filter(Boolean);
                            resolve();
                        });
                    });
                });
            });
        }

        function isModelAFavorite(modelId) {
            if (!modelId) return false;
            const favModelsToLower = favoriteModels.filter(Boolean).map((x) => x.toLowerCase());

            return favModelsToLower.includes(modelId.toLowerCase());
        }

        function addModelToFavorites(modelId) {
            return new Promise(function(resolve, reject) {
                IdentityFactory.getUser()
                .then((res) => {
                    const baseURL = "https://api.smartxadvisory.com/api/4.1/asset-shop";
                    fetch(`${baseURL}/favorites/${modelId}/toggle`, {
                        method: "POST",
                        headers: {
                            Authorization: `Bearer ${res.access_token}`
                        },
                    })
                    .then(() => {
                        getFavoriteModels()
                        .then(() => {
                            resolve();
                        });
                    });
                });
            });
        }

        return {
            favoriteModels: favoriteModels,
            isModelAFavorite: isModelAFavorite,
            getFavoriteModels: getFavoriteModels,
            addModelToFavorites: addModelToFavorites,
        };
    },
]);
